require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-blauwe-sluis.json") })
        }
      }, "path---projecten-blauwe-sluis");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-blauwe-sluis!./.cache/json/projecten-blauwe-sluis.json
// module id = 401
// module chunks = 231608221292675